<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" wrap-class-name="single-spa-vue">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="主键" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入主键"/>
                </a-form-item>
            </div>
            <a-form-item label="角色名称" name="name">
                <a-input v-model:value="form.name" placeholder="请输入角色名称"/>
            </a-form-item>
            <a-form-item label="描述" name="describes">
                <a-textarea v-model:value="form.describes" placeholder="请输入描述" :auto-size="{minRows:3,maxRows:6}"/>
            </a-form-item>
            <a-form-item label="排序值" name="sort">
                <a-input-number v-model:value="form.sort" :min="0" :precision="0" style="width: 100%"/>
            </a-form-item>
            <a-form-item label="启用状态" name="enable">
                <a-radio-group v-model:value="form.enable">
                    <a-radio :value="0">启用</a-radio>
                    <a-radio :value="1">禁用</a-radio>
                </a-radio-group>
            </a-form-item>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {sys_role} from "@/api/adminService";

export default {
    name: "AddOrEditModal",
    mixins: [formMixin],
    components: {},
    data() {
        return {
            form: {
                id: null,
                name: null,
                describes: null,
                sort: null,
            },
            rules: {
                id: [],
                name: [
                    dataCheck.required({}),
                ],
                describes: [
                    dataCheck.required({}),
                ],
                sort: [
                    dataCheck.required({type: "number"}),
                ],
                enable:[
                    dataCheck.required({type: "number"}),
                ],
            },
            submitUrl:sys_role.saveUpdate
        }
    },
    // computed: {
    //     submitUrl() {
    //         return this.form.roleId ? sys_role.update : sys_role.save;
    //     }
    // },
}
</script>
<style scoped lang="less">
</style>
